import React from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import AppBar from '@material-ui/core/AppBar';
import SaveIcon from '@material-ui/icons/Save';
import ReturnIcon from '@material-ui/icons/ArrowBack';
import UsedRentalsTransportAPI from '../../../../API/UsedRentalsTransportAPI';
import ConfirmationDialog from '../../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import UsedRentalsCarsListAPI from '../../../../API/UsedRentalsCarsListAPI';
import { FormatDate } from '../../../Utils/GenericFunctions';
import { handleServerError, handleSpecialCharacters } from '../../../../Utils/Helper';
import { UR_GROUP } from '../../../../Utils/Constants';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import MaskedInput from 'react-text-mask';


const headerData = [
  { id: 'brand', label: 'MARCA' },
  { id: 'carModel', label: 'MODELO' },
  { id: 'color', label: 'COR' },
  { id: 'licensePlate', label: 'MATRÍCULA' },
  { id: 'orderNumber', label: 'Nº ENCOMENDA' },
  { id: 'orderStatus', label: 'ESTADO DA ENCOMENDA' },
  { id: 'customer', label: 'CLIENTE' },
  { id: 'customerExpectedDeliveryDate', label: 'DATA ENTREGA PRETENDIDA PELO CLIENTE' }
];

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  formPadding: {
    padding: '132px 32px 0px 32px',
    flexGrow: 1
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px',
    border: '2px solid #ffffff'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  tableWrapper: {
    overflowX: 'auto',
    padding: 0
  },
  tblRow: {
    height: '30px',
    backgroundColor: '#F2F2F2',
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1'
    }
  },
  cellPadding: {
    paddingLeft: '6px',
  },
  dividerHead: {
    borderBottom: '2px solid #768c09'
  },
  appBar: {
    backgroundColor: '#F6F6F6'
  },
  flex: {
    flex: 1
  },
  toolbarHeight: {
    minHeight: '52px'
  }
});

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd/mm/yyyy', { maxYear: new Date().getFullYear() });

const DateMask = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={' '}
    />
  );
}
DateMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};


class RUTransportsWRTForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      TransportObservations: '',
      OriginLocal: '',
      DestinationLocal: '',
      RequestDate: '',
      DestinationExpectedDate: '',
      DestinationArrivalDate: '',
      EffectiveDeliveryDate: '',
      ExpectedDeliveryDate: '',
      carData: {},
      loading: false,
      success: false,
      openDialog: false,
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      changedValueDetected: false,
      openError: false,
      alertMessage: ''
    };
  }

  componentDidMount() {
    const ruCarAPI = new UsedRentalsCarsListAPI();
    ruCarAPI.getRUCarByL4Id(this.props.carId).then((response) => {
      this.setState({
        TransportObservations: response.data.TransportObservations !== null ? response.data.TransportObservations : '',
        OriginLocal: response.data.OriginalLocation !== null ? response.data.OriginalLocation : '',
        DestinationLocal: response.data.DestinationLocation !== null ? response.data.DestinationLocation : '',
        RequestDate: FormatDate(response.data.RequestDate),
        DestinationExpectedDate: FormatDate(response.data.DestinationExpectedDate),
        EffectiveDeliveryDate: FormatDate(response.data.EffectiveDeliveryDate),
        DestinationArrivalDate: FormatDate(response.data.DestinationArrivalDate),
        ExpectedDeliveryDate: FormatDate(response.data.ExpectedDeliveryDate),
        carData: response.data
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleClose = () => {
    this.props.handleClose();
  };

  handleCloseDialog = () => {
    this.setState({
      openDialog: false,
      loading: false,
      success: false
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleChange = name => event => {
    this.setState({ [name]: handleSpecialCharacters(event.target.value) });
    this.detectChange();
  };

  detectChange = () => {
    this.setState({ changedValueDetected: true });
  };

  handleGoBack = () => {
    if (this.state.changedValueDetected === true) {
      this.setState({
        openDialog: true,
        confirmationQuestion: 'Tem a certeza que pretende RETROCEDER sem guardar as alterações?',
        confirmationMessage: 'A informação relativamente às alterações executadas será perdida.',
        confirmationFunction: this.handleClose,
        cancelFunction: this.handleCloseDialog
      });
    }
    else {
      this.handleClose();
    }
    this.props.reloadTableEdit()
  };

  handleClickSaveCarTransportInfo = (carBrand, carModel, carLicensePlate) => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende GUARDAR a informação da viatura?',
      confirmationMessage: 'A informação relativamente à viatura da marca ' + carBrand + ', modelo ' + carModel +
        (carLicensePlate !== null && carLicensePlate !== '' ? ' e matrícula ' + carLicensePlate : '') + ' será guardada.',
      confirmationFunction: this.handleSubmitSaveCarTransportInfo,
      cancelFunction: this.handleCloseDialog
    });
  }

  handleSubmitSaveCarTransportInfo = () => {
    const transportAPI = new UsedRentalsTransportAPI();
    this.setState({ loading: true })
    let transportDTO = this.parseStateForSubmit(this.state);
    transportAPI.updateRUTransportByCar(transportDTO).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.handleCloseDialog();
        this.handleClose();
      }, 500)
      this.props.reloadTableEdit();
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog();
    });
  };

  parseStateForSubmit(estado) {
    return {
      L4ID: this.props.carId,
      TransportObservations: estado.TransportObservations,
      OriginalLocation: estado.OriginLocal,
      DestinationLocation: estado.DestinationLocal,
      RequestDate: estado.RequestDate,
      DestinationExpectedDate: estado.DestinationExpectedDate,
      DestinationArrivalDate: estado.DestinationArrivalDate,
      ExpectedDeliveryDate: estado.ExpectedDeliveryDate
    }
  }

  renderTableHeader() {
    const { classes } = this.props;

    return (
      <TableRow className={classes.headerHeight} >
        {headerData.map(column => {
          return (
            <TableCell key={column.id} padding='none' className={classNames(classes.tblHeadT, classes.textCenter)}>
              {column.label}
            </TableCell>
          );
        }, this)}
      </TableRow>
    );
  }

  renderTableRecords(carInformation, lotInfo) {
    const { classes } = this.props;

    return (
      <TableRow tabIndex={-1} key={carInformation.Id} className={classes.tblRow}>
        <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
          {lotInfo.CarBrand}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
          {lotInfo.CarModel}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {lotInfo.ColourDescription}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInformation.LicensePlate}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInformation.OrderNumber}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInformation.OrderStatus}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {carInformation.ClientName}
        </TableCell>
        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
          {FormatDate(carInformation.CustomerExpectedDeliveryDate)}
        </TableCell>
      </TableRow>
    );
  }


  render() {
    const { classes } = this.props;

    return (
      <div>
        <AppBar className={classes.appBar}>

          <Toolbar className={classes.toolbarHeight}>
            <Tooltip title='Retroceder' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleGoBack}>
                <ReturnIcon />
              </Button>
            </Tooltip>
            <Typography variant='title' className={classNames(classes.flex, classes.textBlack)}>
              GESTÃO DE TRANSPORTE
            </Typography>
            <Tooltip title='Guardar' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleClickSaveCarTransportInfo(this.props.lotInfo.CarBrand, this.props.lotInfo.CarModel, this.state.carData.LicensePlate) }}
                disabled={this.props.user.UserRoleType.indexOf(UR_GROUP) < 0}>
                <SaveIcon />
              </Button>
            </Tooltip>
          </Toolbar>

          <Paper className={classes.tableWrapper}>
            <Table>
              <TableHead className={classes.tblHead}>
                {this.renderTableHeader()}
              </TableHead>
              <TableBody>
                {this.renderTableRecords(this.state.carData, this.props.lotInfo)}
              </TableBody>
            </Table>
          </Paper>

        </AppBar>

        <form className={classes.formPadding}>
          <Grid container spacing={8}>
            <Grid item xs={12} sm={12}>
              <Typography className={classes.dividerHead} variant='headline'>TRANSPORTE</Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id='transportObservations'
                label='OBSERVAÇÕES TRANSPORTE'
                fullWidth
                multiline
                rows='1'
                rowsMax='3'
                inputProps={{ readOnly: this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, maxLength: 500 }}
                value={this.state.TransportObservations}
                onChange={this.handleChange('TransportObservations')}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id='originLocal'
                label='LOCAL DE ORIGEM'
                fullWidth
                inputProps={{ readOnly: this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, maxLength: 200 }}
                value={this.state.OriginLocal}
                onChange={this.handleChange('OriginLocal')}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id='destinationLocal'
                label='LOCAL DE DESTINO'
                fullWidth
                inputProps={{ readOnly: this.props.user.UserRoleType.indexOf(UR_GROUP) < 0, maxLength: 200 }}
                value={this.state.DestinationLocal}
                onChange={this.handleChange('DestinationLocal')}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='RequestDate'
                label='DATA PEDIDO TRANSPORTE (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputProps={{
                  inputComponent: DateMask,
                  value: this.state.RequestDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  onChange: this.handleChange('RequestDate'),
                  guide: false,
                  readOnly: this.props.user.UserRoleType.indexOf(UR_GROUP) < 0
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='DestinationExpectedDate'
                label='DATA PREVISTA CHEGADA DESTINO (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputProps={{
                  inputComponent: DateMask,
                  value: this.state.DestinationExpectedDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  onChange: this.handleChange('DestinationExpectedDate'),
                  guide: false,
                  readOnly: this.props.user.UserRoleType.indexOf(UR_GROUP) < 0
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='DestinationArrivalDate'
                label='DATA CHEGADA DESTINO (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputProps={{
                  inputComponent: DateMask,
                  value: this.state.DestinationArrivalDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  onChange: this.handleChange('DestinationArrivalDate'),
                  guide: false,
                  readOnly: this.props.user.UserRoleType.indexOf(UR_GROUP) < 0
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id='EffectiveDeliveryDate'
                label='DATA EFETIVA ENTREGA (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputProps={{
                  inputComponent: DateMask,
                  value: this.state.EffectiveDeliveryDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  onChange: this.handleChange('EffectiveDeliveryDate'),
                  guide: false,
                  readOnly: true
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                id='ExpectedDeliveryDate'
                label='DATA PREVISTA DE ENTREGA (dd/mm/aaaa)'
                fullWidth
                type='text'
                InputProps={{
                  inputComponent: DateMask,
                  value: this.state.ExpectedDeliveryDate,
                  pipe: autoCorrectedDatePipe,
                  placeholder: '',
                  onChange: this.handleChange('ExpectedDeliveryDate'),
                  guide: false,
                  readOnly: this.props.user.UserRoleType.indexOf(UR_GROUP) < 0
                }}
              />
            </Grid>
          </Grid>
        </form>

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleCloseDialog.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    )
  }
}

RUTransportsWRTForm.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(RUTransportsWRTForm));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsTransport/UsedRentalsWaitingRequest/RUTransportsWRTForm.js